import mixinsCommit from '@/store/mixins/mixinsCommit';

export default {
  ...mixinsCommit,
};
